import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
export const sizeMap = {
    large: {
        borderRadius: '6px',
        fontSize: tokens.fontSizes.medium,
        sizing: '12px',
        spacing: tokens.spacing.medium,
    },
    medium: {
        borderRadius: tokens.borderRadius.medium,
        fontSize: tokens.fontSizes.small,
        sizing: '8px',
        spacing: tokens.spacing.medium,
    },
    small: {
        borderRadius: '2px',
        fontSize: tokens.fontSizes.xsmall,
        sizing: '4px',
        spacing: tokens.spacing.small,
    },
};
const variantMap = {
    default: {
        backgroundColor: theme.brand.main,
    },
    error: {
        backgroundColor: theme.error.main,
    },
    upgrade: {
        backgroundColor: theme.upgrade.main,
    },
    warning: {
        backgroundColor: theme.warning.lighter,
    },
};
const wrapperStaticStyle = css({
    alignItems: 'center',
    color: theme.text.subtle,
    display: 'flex',
    fontFamily: tokens.fontFamilies.sansSerif,
    gap: tokens.spacing.small,
    lineHeight: tokens.lineHeights.tight,
    width: '100%',
});
export function wrapperStyle({ inverted, size }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        wrapperStaticStyle,
        css({
            fontSize: sizeMap[size].fontSize,
        }),
    ];
}
export const progressWrapperStaticStyle = css({
    display: 'inline-flex',
    flex: 1,
    position: 'relative',
    width: '100%',
});
export const stepClipWrapperStaticStyle = css({
    display: 'flex',
    flexWrap: 'nowrap',
    height: '1px',
    position: 'absolute',
    width: '100%', // Height must be set to at least 1px for Safari to behave
});
export function stepClipStyle({ index, max, size }) {
    // startPosX is for determining start location
    const startPosX = `${(100 / max) * index}%`;
    const width = `${100 / max}%`;
    //  Emotion does not like the 'x' attribute, but it is supported in all modern browsers
    return css({
        height: sizeMap[size].sizing,
        width: `calc(${startPosX === '0%' ? width : `${width} - 4px`})`,
        x: `calc(${startPosX === '0%' ? 0 : `${startPosX} + 4px`})`,
    });
}
const progressIndicatorStaticStyle = css({
    transition: 'width 1s ease-in-out',
});
function progressIndicatorStyle({ size, variant, }) {
    return [
        progressIndicatorStaticStyle,
        css({
            backgroundColor: variantMap[variant].backgroundColor,
            borderRadius: sizeMap[size].borderRadius,
        }),
    ];
}
const progressStaticStyle = css({
    '&::-webkit-progress-bar': {
        backgroundColor: 'inherit',
    },
    appearance: 'none',
    backgroundColor: theme.transparentGrey.lighter,
    border: 'none',
    width: '100%',
});
export function progressStyle({ clipId, size, variant }) {
    return [
        progressStaticStyle,
        css({
            // Progress value indicator
            '&::-moz-progress-bar': progressIndicatorStyle({ size, variant }),
            // Container for the progress indicator
            '&::-webkit-progress-bar': {
                borderRadius: sizeMap[size].borderRadius,
            },
            // Cannot use comma separated list due to common issue with these pseudo-selectors
            '&::-webkit-progress-value': progressIndicatorStyle({ size, variant }),
            borderRadius: sizeMap[size].borderRadius,
            clipPath: `url(#${clipId})`,
            height: sizeMap[size].sizing,
        }),
    ];
}
